import { useCallback } from 'react'

import { useApiLazy } from '../../../hooks/useApiLazy'
import { UserMetadataPrivacyQualifiers, UserPrivacyQualifiersPutBody } from '../types'

export type UseUserUpdatePrivacyQualifiers = [
  updateUserPrivacyQualifiers: ({
    privacy_qualifiers,
  }: UserMetadataPrivacyQualifiers) => Promise<void>,
]

export const useUserUpdatePrivacyQualifiers = (): UseUserUpdatePrivacyQualifiers => {
  const [doApiRequest] = useApiLazy<UserMetadataPrivacyQualifiers, UserPrivacyQualifiersPutBody>()

  const updateUserPrivacyQualifiers = useCallback(
    async ({ privacy_qualifiers }: UserMetadataPrivacyQualifiers): Promise<void> => {
      const result = await doApiRequest('/api/user/privacy-qualifiers', {
        loginRequired: true,
        method: 'PUT',
        body: {
          data: {
            privacy_qualifiers: privacy_qualifiers,
          },
        },
      })
      if (result._tag === 'Left') {
        throw result.error
      }
    },
    [doApiRequest],
  )

  return [updateUserPrivacyQualifiers]
}
